import { ArrayParam, StringParam } from "use-query-params";

export type ClientsFilters = {
  company?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  type?: string[] | null;
};

export type GetClientsFilterParams = {
  company?: string;
  email?: string;
  phoneNumber?: string;
  type?: string[];
};

export const ClientsFilterParams = {
  company: StringParam,
  email: StringParam,
  phoneNumber: StringParam,
  type: ArrayParam,
};
